<template>
    <div v-if="display" class="dialog">
        <div class="dialog-inner">
            <slot></slot>
        </div>
        <div @click="show(false)" class="modal"></div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            display : false
        }
    },
    methods: {
        show(status = true){
            this.display = status
        }
    },
}
</script>
<style lang="scss">
    .dialog{
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        .dialog-inner{
            width: 90%;
            background-color: white;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            border-radius: 4px;
        }
        .modal{
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: -1;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, .4);
        }
    }
</style>